export default __webpack_public_path__ + "static/media/screenshot1.d1658d80.png";